import type { SxProps } from '@mui/material';
import {
  DropdownStepper,
  Stepper as PantryStepper,
  useIsMobile,
} from '@side/pantry';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { OFFER_STEPS } from '../../constants/steps';
import { useCreateOfferContext } from '../../context/CreateOfferContext';
import { useUpdateStep } from '../../hooks/useUpdateStep';

interface Props {
  sx?: SxProps;
}

export const Stepper = ({ sx }: Props) => {
  const isMobile = useIsMobile('lg');
  const updateStep = useUpdateStep();
  const { step } = useCreateOfferContext();

  const {
    formState: { isValid },
  } = useFormContext();

  const stepperSteps = useMemo(() => {
    const addressNotComplete = step === OFFER_STEPS.address && !isValid;

    return [
      {
        label: 'Property Address',
        onClick: () => updateStep(OFFER_STEPS.address),
        completed: step > OFFER_STEPS.address,
      },
      {
        label: 'Contact Details',
        onClick: () => updateStep(OFFER_STEPS.buyer),
        disabled: addressNotComplete,
      },
    ];
  }, [isValid, step, updateStep]);

  if (isMobile) {
    return (
      <DropdownStepper
        activeStep={step}
        onChangeActiveStep={updateStep}
        steps={stepperSteps}
        sx={sx}
      />
    );
  }

  return (
    <PantryStepper
      activeStep={step}
      steps={stepperSteps}
      sx={{
        backgroundColor: 'background.paper',
        width: 270,
        height: 'min-content',
      }}
    />
  );
};
